// @ts-nocheck

import { createSelector } from 'reselect';

import { GRRoundIndexByRoundId } from '../../constants/order';
import { GRRounds } from '../../types/round';
import { GRRoundUserStatuses } from '../../types/user';
import { selectGRUserCurrentRoundStatus } from '../user';

import { selectGRGlobalStatus } from './selectGRRuntime';

const selectUserRound = createSelector([(state) => state.gr.user?.round], (userRound) => userRound ?? null);

const selectUserRoundIndex = createSelector([selectUserRound], (userRound) =>
  userRound ? GRRoundIndexByRoundId[userRound] : null,
);

const selectUserHomeVisitedIndex = createSelector(
  [(state) => state.gr.misc?.homeVisitedIndex],
  (homeVisitedIndex) => homeVisitedIndex ?? null,
);

const selectIndex = createSelector(
  [selectUserRoundIndex, selectUserHomeVisitedIndex],
  (userRoundIndex, homeVisitedIndex) => homeVisitedIndex ?? userRoundIndex,
);

const selectHasUserWonLastRound = createSelector(
  [selectUserRound, selectGRUserCurrentRoundStatus],
  (userRound, roundStatus) => userRound === GRRounds.SHIRT && roundStatus === GRRoundUserStatuses.WON,
);

const selectGRHomeProps = createSelector(
  [selectIndex, selectGRGlobalStatus, selectHasUserWonLastRound],
  (index, globalStatus, didUserWonLastRound) => ({
    index,
    globalStatus,
    didUserWonLastRound,
  }),
);

export default selectGRHomeProps;
